// extracted by mini-css-extract-plugin
export var orderSummary = "_po-0";
export var showMoreLessButton = "_po-1";